export default {
  "app-dashboard": "Application control panel with package management and system metrics",
  "system-dashboard": "System telemetry, health monitoring, bandwidth, CPU and memory charts",
  "sd-overview": "System Dashboard overview: the top metrics strip and status summary",
  "sd-service-health": "Service health status and details for installed applications",
  "sd-cpu-memory": "CPU, memory and swap usage history charts",
  "sd-raid": "Software RAID array status, rebuild and disk health",
  "sd-hardware": "Hardware health: CPU, memory, sensors, firmware and power profile",
  "sd-telemetry-store": "Telemetry history retention, purge and clear operations",
  "sd-transfers": "Inter-instance transfers between sender and receiver servers",
  "sd-fail2ban": "Fail2Ban jail status and banned IP protection",
  "sd-maintenance": "Streaming maintenance and cleanup operations",
  "sd-updates": "Check for and apply dashboard updates",
  "sd-diagnostics": "Core and dashboard version, uptime, and redacted diagnostics export",
  "sd-users": "System user accounts overview",
  "sd-inventory": "System inventory: OS, kernel, services and versions",
  "streaming-dashboard": "Media server streaming sessions and watch activity monitoring",
  "wsd-analytics": "Watch analytics and streaming statistics",
  "wsd-logs": "Streaming activity logs and event history",
  "wsd-settings": "Streaming dashboard configuration and connection settings",
  "wsd-control-center": "Central management hub for media server administration",
  "cc-overview": "Control Center overview with server status, users and API keys",
  "cc-server-users": "Media server user management and access control",
  "cc-devices": "Connected devices and client management",
  "cc-media-portal": "Immersive cinematic media browsing surface for movies, TV shows and music",
  "cc-history-analytics": "Streaming watch history and playback analytics for media server sessions",
  "settings-email": "Email server configuration and template management",
  "es-provider": "Email provider and SMTP connection settings",
  "es-templates": "Email template editing and customization",
  "es-advanced": "Advanced email delivery options and tuning",
  "es-log": "Email delivery log and send history",
  "settings-notifications": "System notification preferences and delivery settings",
  "ns-compose": "Compose and broadcast a notification to users",
  "ns-history": "History of sent notifications and delivery status",
  "ns-templates": "Reusable notification templates",
  "ns-channels": "Notification delivery channels: Discord, Signal, WhatsApp and more",
  "ns-command": "Command channel for remote server control via chat",
  "settings-general": "Core dashboard settings including instance, timezone, display and branding",
  "gs-instance-settings": "Instance name, URL and core configuration",
  "gs-timezone-locale": "Timezone and locale configuration",
  "gs-sessions-security": "Session security and authentication settings — moved to Session Settings",
  "gs-display-preferences": "Dashboard display and visual preferences",
  "gs-additional-dashboard-settings": "Additional dashboard configuration including Redis, disk, network and bandwidth",
  "gs-uploads": "File upload size limits and configuration",
  "gs-branding": "Dashboard branding, logo and visual identity",
  "gs-auth-pages": "Login and registration page customization",
  "gs-feature-flags": "Enable or disable dashboard features",
  "settings-sessions": "Session timeout, persistence and concurrency settings",
  "ss-timeouts": "Session and idle timeout duration configuration",
  "ss-persistence-cookies": "Session persistence and cookie settings",
  "ss-concurrency": "Concurrent session limits per user",
  "ss-session-operations": "Bulk session management operations",
  "settings-security": "Security enforcement, banned IPs, and network controls",
  "sec-firewall-rules": "View and manage iptables firewall rules and network filtering",
  "sec-geo-lock": "Lock dashboard access to specific countries using GeoIP filtering",
  "sec-geo-block": "Block dashboard access from specific countries using GeoIP filtering",
  "sec-fail2ban": "Manage Fail2Ban jails, allowlists, and intrusion prevention settings",
  "sec-restricted-shell": "Configure the restricted login shell (lshell) policy for non-admin users",
  "settings-registration": "User registration policies, quotas and welcome email",
  "reg-activation": "Registration activation mode and invitation settings",
  "reg-quotas": "Disk quota and resource limits for new users",
  "reg-default-group": "Default user group assigned to new registrations",
  "reg-username-policy": "Username format requirements and restrictions",
  "reg-password-policy": "Password strength requirements and rules",
  "reg-welcome-email": "Welcome email template sent to new users",
  "users-admin": "Create, manage, ban and delete user accounts",
  "users-groups": "User group management and application access control",
  "users-roles": "Role definitions and permission assignment",
  "system-db-management": "Database management via phpMyAdmin",
  "system-console": "Web-based terminal for server administration",
  "system-api-settings": "API key management and configuration",
  "system-app-templates": "Application definition templates and customization",
  "system-ssl-control": "SSL/TLS certificate management via Let's Encrypt",
  "system-vpn-control": "WireGuard VPN peer configuration and management",
  "system-delete-protection": "Safeguard the server against freezes caused by large file deletes on media and download apps",
  "system-network": "Network interface throughput, bandwidth usage, and connection monitoring",
  "transfers-control": "Move data between your own QuickBox instances with verified, resumable, approval-gated transfers",
  "system-news": "News announcements and release notes from QuickBox",
  "system-changelog": "Version history, changelog and update center",
  "system-logs": "System logs, audit trail and application events",
  "system-documentation": "QuickBox Pro documentation and guides",
  "profile-picture": "Update your profile picture and avatar",
  "profile-account": "Account settings and personal information",
  "profile-links": "Quick navigation links on your profile",
  "profile-system-metrics": "Personal disk usage and system resource metrics",
  "security-passkeys": "Manage passkeys for passwordless authentication",
  "security-2fa": "Two-factor authentication setup and management",
  "security-sessions": "View and manage your active login sessions",
  "notification-settings-channels": "Configure notification delivery channels",
  "notification-settings-channel-setup": "Set up and test notification channels",
  "notification-settings-disk-usage": "Disk usage alert thresholds and notifications",
  "notification-settings-events": "Notification event preferences and subscriptions",
  "notification-settings-updates-digest": "Consolidate pending update notifications into a scheduled summary email",
  "notification-settings-events-applications": "Notification preferences for app health, lifecycle, and update alerts",
  "notification-settings-events-security": "Notification preferences for login, session, password, and MFA changes",
  "notification-settings-events-automation": "Notification preferences for background tasks and scheduled jobs",
  "notification-settings-events-support": "Notification preferences for support tickets and direct messages",
  "notification-settings-events-digest": "Notification preferences for daily and weekly digest emails and quiet hours",
  "notification-center-all": "View all your notifications",
  "support-access": "Enable or disable support team access to your server",
  "media-management-bazarr": "Subtitle management and downloading",
  "media-management-lazylibrarian": "Book and audiobook management",
  "media-management-lidarr": "Music collection management",
  "media-management-listenarr": "Audiobook collection management and automation",
  "media-management-medusa": "TV show management and automation",
  "media-management-mylar3": "Comic book management",
  "media-management-radarr": "Movie collection management and automation",
  "media-management-readarr": "Book and ebook management",
  "media-management-sickchill": "TV show management",
  "media-management-sickgear": "TV show management and automation",
  "media-management-sonarr": "TV series management and automation",
  "media-servers-airsonic": "Music streaming server",
  "media-servers-audiobookshelf": "Audiobook and podcast server",
  "media-servers-dispatcharr": "IPTV stream aggregator and EPG proxy",
  "media-servers-emby": "Media server for movies, TV and music",
  "media-servers-jellyfin": "Free and open-source media server",
  "media-servers-plex": "Media server for streaming movies, TV and music",
  "media-servers-subsonic": "Music streaming server",
  "media-servers-tautulli": "Plex monitoring and statistics",
  "media-servers-xteve": "IPTV proxy for Plex and Emby",
  "media-requests-jellyseerr": "Media request management for Jellyfin",
  "media-requests-ombi": "Media request and user management",
  "media-requests-overseerr": "Media request management for Plex",
  "media-requests-requestrr": "Discord-based media requesting",
  "media-requests-seerr": "Media request management",
  "download-clients-deluge": "Lightweight BitTorrent client",
  "download-clients-flood": "Modern web UI for rTorrent",
  "download-clients-jdownloader": "Direct download manager",
  "download-clients-nzbget": "Usenet download client",
  "download-clients-pyload": "Download manager for file hosting sites",
  "download-clients-qbittorrent": "Feature-rich BitTorrent client",
  "download-clients-rtorrent": "Console-based BitTorrent client",
  "download-clients-rutorrent": "Web frontend for rTorrent",
  "download-clients-sabnzbd": "Usenet download client",
  "download-clients-transmission": "Lightweight BitTorrent client",
  "indexers-autobrr": "IRC and torrent automation",
  "indexers-autodl": "IRC torrent auto-downloader",
  "indexers-jackett": "Torrent/NZB indexer proxy",
  "indexers-nzbhydra2": "NZB meta search aggregator",
  "indexers-prowlarr": "Indexer management and proxy",
  "automation-autoscan": "Automated media library scanning",
  "automation-filebot": "Media file renaming and organization",
  "automation-flaresolverr": "Cloudflare challenge solver proxy",
  "automation-flexget": "Multipurpose automation tool",
  "automation-headphones": "Music download automation",
  "automation-notifiarr": "Discord notification integration",
  "automation-seedcross": "Cross-seed torrent automation",
  "automation-unmanic": "Library auto-transcoder",
  "automation-unpackerr": "Automated archive extraction",
  "file-management-btsync": "Peer-to-peer file synchronization",
  "file-management-duplicati": "Encrypted backup solution",
  "file-management-filebrowser": "Web-based file manager",
  "file-management-nextcloud": "Self-hosted cloud storage and collaboration",
  "file-management-rclone": "Cloud storage sync and management",
  "file-management-syncthing": "Continuous file synchronization",
  "readers-calibre": "Ebook management and conversion",
  "readers-kavita": "Self-hosted digital library",
  "readers-komga": "Comic and manga server",
  "remote-access-novnc": "Browser-based VNC remote desktop",
  "remote-access-webconsole": "Web-based terminal access",
  "remote-access-x2go": "Remote desktop access",
  "communication-quassel": "IRC client with detachable core",
  "communication-thelounge": "Self-hosted web IRC client",
  "communication-znc": "IRC bouncer and proxy",
  "utilities-fail2ban": "Intrusion prevention and log monitoring",
  "utilities-lecert": "SSL certificate management via Let's Encrypt",
  "utilities-netdata": "Real-time system monitoring dashboard",
  "utilities-phpmyadmin": "Web-based MySQL/MariaDB administration",
  "utilities-vpn": "VPN service management",
  "utilities-wireguard": "Modern VPN using WireGuard protocol",
  "content-media-library": "Manage assets, branding, app logos, and avatars",
  "ml-local-assets": "Your uploaded local assets and images",
  "ml-brand-assets": "Dashboard brand assets: logos, favicon, default avatar",
  "ml-app-logos": "Custom application logos and icons",
  "ml-avatars": "User avatar library and default avatars",
  "ml-app-backups": "Application backup archives and restore points",
  "cc-media-requests": "Review, approve, and deny media requests from Seerr and Ombi",
  "users-registration": "User registration management and pending invitations",
  "content-instance-name": "The display name for your QuickBox Pro instance",
  "content-admin-email": "Contact email for system notifications",
  "content-web-root": "Base URL for dashboard access (auto-detected if empty)",
  "content-timezone": "System timezone for date and time display",
  "content-date-format": "Format used for displaying dates throughout the dashboard",
  "content-default-page": "Landing page shown after login for regular users",
  "content-admin-default-page": "Landing page shown after login for admin users",
  "content-default-theme": "Theme applied to new user accounts by default",
  "content-disk-mount": "Filesystem mount point for disk usage monitoring",
  "content-network-interface": "Network interface used for bandwidth statistics",
  "content-vnstat": "vnStat bandwidth monitoring configuration",
  "content-redis-cache": "Redis connection for caching and session storage",
  "content-avatar-max-size": "Maximum file size for user avatar uploads",
  "content-banner-max-size": "Maximum file size for user banner uploads",
  "content-allow-avatar-upload": "Toggle to let users upload custom profile avatars",
  "content-collapsed-logo": "Small logo shown when sidebar is collapsed",
  "content-full-logo": "Full logo shown when sidebar is expanded",
  "content-favicon": "Browser tab favicon for the dashboard",
  "content-default-avatar": "Default avatar used for users without a custom avatar",
  "content-auth-show-logo": "Show or hide the logo on login and registration pages",
  "content-auth-login-message": "Custom welcome message displayed on auth pages (Markdown supported)",
  "content-maintenance-mode": "Show maintenance page to non-admin users",
  "content-user-registration": "Allow or block new user registrations",
  "content-notification-channels": "Control external notification channel access for non-admin users",
  "content-web-console": "Browser-based terminal for admin server access",
  "content-delete-protection": "Guard the server against freezes caused by large file deletes on media and download apps",
  "content-mask-banned-ips": "Hide the last octet of banned attacker IPs on the Fail2Ban dashboard",
  "content-auto-protect-apps": "Automatically enable Fail2Ban brute-force protection for supported apps on install",
  "content-transfer-toggle": "Enable moving data between your own QuickBox instances",
  "content-wsdashboard": "Real-time streaming session monitor for Emby and Jellyfin",
  "content-playback-mirror": "Mirror active playback sessions in read-only mode",
  "content-user-timeout": "Minutes of inactivity before a user session expires",
  "content-guest-timeout": "Minutes of inactivity before a guest session expires",
  "content-remember-me": "Duration for 'Remember me' cookies before expiry",
  "content-auto-extend": "Reset session timer on each request to keep active users logged in",
  "content-multiple-sessions": "Allow or block simultaneous login sessions per user",
  "content-invalidate-sessions": "Force all non-admin users to log in again",
  "content-disallowed-usernames": "Manage usernames blocked from registration and login",
  "content-banned-ips": "Block IP addresses with application-level and iptables enforcement",
  "content-network-enforcement": "Manage iptables-level IP/CIDR blocks via the QBX_ENFORCEMENT chain",
  "content-activation-mode": "How new accounts are activated after registration",
  "content-default-quota": "Default disk quota assigned to new user accounts",
  "content-default-group": "Default user group assigned to new registrations",
  "content-username-min-length": "Minimum character length for usernames",
  "content-username-max-length": "Maximum character length for usernames",
  "content-force-lowercase": "Automatically convert usernames to lowercase during registration",
  "content-username-regex": "Custom regex pattern for username validation",
  "content-password-min-length": "Minimum character length for passwords",
  "content-password-max-length": "Maximum character length for passwords",
  "content-welcome-email": "Send a welcome email to new users after registration",
  "content-firewall-origin-filter": "Filter firewall rules by origin: QuickBox, Fail2Ban, WireGuard, Geo Policy, or System",
  "content-firewall-bulk-delete": "Select and bulk-remove QBX-managed firewall rules",
  "content-geo-lock-add-rule": "Create geo-lock rules to restrict streaming access by country",
  "content-geo-lock-violations": "View recent geo-lock violation events and blocked access attempts",
  "content-geo-block-countries": "Select countries to block or allow in the geo-block policy",
  "content-geo-block-enforcement": "Apply or disable geo-block firewall enforcement",
  "content-geo-block-ip-test": "Test whether a specific IP address would be allowed or blocked",
  "content-transfers-send": "Send data to one of your other QuickBox instances and track outgoing offers",
  "content-transfers-incoming": "Review and approve incoming transfer offers from your other instances",
  "content-transfers-history": "View completed and terminal transfers, incoming and outgoing",
  "content-transfers-settings": "Configure transfer defaults: throttle, off-peak window, chunk size and data port",
  "content-delete-protection-restore": "Review recent large-file deletes and restore or prune protected deletions",
  "content-delete-protection-services": "Per-app delete-protection status and enable/disable toggles",
  "content-delete-protection-custom": "Register a custom app for delete protection with its own recipe",
  "content-sysdash-quick-actions": "Quick action shortcuts for common system operations",
  "content-sysdash-telemetry-sources": "Configured telemetry collectors and metric sources",
  "content-sysdash-health-details": "Detailed per-service health checks and status breakdown",
  "content-sysdash-health-score": "Overall system health score and rating",
  "content-vpn-peers": "WireGuard peer configurations, client profiles and tunnels",
  "content-vpn-upload": "Upload and import a client VPN configuration file",
  "content-vpn-app-routing": "Route specific apps through the VPN tunnel (split tunneling)",
  "content-vpn-history": "VPN connection history and past sessions",
  "content-vpn-openvpn": "OpenVPN server status and configuration",
  "content-vpn-lifecycle": "Config lifecycle policy: rotation and expiry of VPN client configs",
  "content-vpn-killswitch": "VPN kill switch and leak-protection failsafe",
  "content-ssl-installed": "View installed SSL/TLS certificates and their status",
  "content-ssl-issue": "Issue a new SSL certificate via Let's Encrypt",
  "content-apptpl-defaults": "Default application definition templates",
  "content-apptpl-customized": "Customized application templates that override the defaults",
  "content-api-keys": "Generate, view and revoke API keys and tokens",
  "content-audit-log": "Immutable audit trail of admin and system actions",
  "content-package-management": "Install, remove, reinstall and update applications",
  "content-users-create": "Create a new user account"
} as const;
